import { render, staticRenderFns } from "./GUStatistics.vue?vue&type=template&id=3babfcea&"
import script from "./GUStatistics.vue?vue&type=script&lang=js&"
export * from "./GUStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports